export default __webpack_public_path__ + "static/breaking-records-background-e56bf5aa1abc46854ce62e1a59e841bf.jpg";